import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
// Importar los estilos de Swiper
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import CardProductos from "./CardProductos";
import imgI from "../assets/images/icons/arrowI.svg";
import imgD from "../assets/images/icons/arrowD.svg";

export default function Productos({ productos, showArrows = true }) {
  return (
    <section className="w-full bg-sidom-light dark:bg-sidom-blue relative z-0">
      <div className="relative w-full  bg-sidom-light dark:bg-sidom-blue ">
        <Swiper
          modules={[Navigation, Autoplay]}
          slidesPerView={1}
          spaceBetween={10}
          loop={true}
          navigation={
            showArrows
              ? {
                  prevEl: ".swiper-button-prev-custom",
                  nextEl: ".swiper-button-next-custom",
                }
              : false
          }
          pagination={{ clickable: true }}
          breakpoints={{
            540: {
              slidesPerView: 1.8,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 40,
            },
            831: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            1040: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            1724: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
          }}
          className="productos-swiper w-full"
        >
          {productos.map((producto, index) => (
            <SwiperSlide
              key={index}
              className="swiper mySwiper  flex justify-center items-center bg-sidom-light dark:bg-sidom-blue"
            >
              <div class="swiper-slide">
                <CardProductos
                  icon={producto.logo?.url}
                  img={producto.img?.url || producto.img}
                  title={producto.titulo || producto.title}
                  description={
                    producto.descripcion?.[0]?.children?.[0]?.text ||
                    producto.description?.[0]?.children?.[0]?.text ||
                    producto.description
                  }
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Flechas navegación responsive */}
        {showArrows && (
          <>
            <button className="swiper-button-prev-custom absolute -left-7 sm:-left-3 md:-left-8 top-[60%] -translate-y-1/2 z-30 p-1 lg:p-3 xl:p-3 hover:opacity-75 transition-all duration-300">
              <img src={imgI} alt="Flecha izquierda" className="w-5" />
            </button>
            <button className="swiper-button-next-custom absolute -right-7 sm:-right-3  md:-right-8 top-[60%] -translate-y-1/2 z-30 p-1 lg:p-3 xl:p-3  hover:opacity-75 transition-all duration-300">
              <img src={imgD} alt="Flecha derecha" className="w-5" />
            </button>
          </>
        )}
      </div>
    </section>
  );
}
